@let loading = loading$ | async;
@let error = error$ | async;
@let roles = roles$ | async;
@let changed = changed$ | async;

<header class="rms-dialog-header">
  <div class="rms-dialog-header-content">
    <h3 class="rms-dialog-header-content-title">
      {{ "partners.users.role.title" | translate: { name: data.user.full_name } }}
    </h3>
  </div>
  <rms-close-button mat-dialog-close />
</header>

<div class="flex flex-col gap-2">
  @if (error) {
    <rms-toast
      icon="remix:System/error-warning-fill"
      color="ochraceus"
      [message]="error" />
  }

  <form
    class="flex flex-col gap-4"
    [formGroup]="form"
    (ngSubmit)="submit()">
    <div class="form-control">
      <label
        id="role-label"
        for="role">
        {{ "partners.users.edit.form.role.label" | translate }}
      </label>
      <mat-form-field subscriptSizing="dynamic">
        <mat-select
          id="role"
          aria-labelledby="role-label"
          formControlName="role">
          @for (option of roles; track option.id) {
            <mat-option [value]="option.id">{{ roleLabels[option.name] | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="rms-dialog-actions">
      <button
        type="button"
        class="rms-dialog-actions-button"
        mat-button
        mat-dialog-close>
        {{ "libs.common.cancel" | translate }}
      </button>
      <button
        type="submit"
        color="primary"
        class="rms-dialog-actions-button"
        mat-raised-button
        [disabled]="role.invalid || loading || !changed">
        @if (loading) {
          <mat-progress-spinner
            class="stroke-white"
            mode="indeterminate"
            [diameter]="30" />
        } @else {
          {{ "partners.users.role.submit" | translate }}
        }
      </button>
    </div>
  </form>
</div>
